<template>
  <div
    title="Сменить тему"
    class="d-flex align-items-center"
  >
    <b-form-checkbox
      v-model="darkThemeEnabled"
      name="is-vertical-menu-collapsed"
      class="mr-25"
      switch
      inline
      @change="onChange"
    />
    <span @click="onClick">Темная тема</span>
  </div>
</template>

<script>
import useAppConfig from '@/core/app-config/useAppConfig'
import { ref } from 'vue'
import { BFormCheckbox } from 'bootstrap-vue'

export default {
  components: {
    BFormCheckbox
  },
  setup() {
    const { skin } = useAppConfig()
    const darkThemeEnabled = ref(skin.value === 'dark')
    const onChange = () => {
      skin.value = darkThemeEnabled.value ? 'dark' : 'light'
    }
    const onClick = () => {
      darkThemeEnabled.value = !darkThemeEnabled.value
      skin.value = darkThemeEnabled.value ? 'dark' : 'light'
    }
    return { skin, darkThemeEnabled, onChange, onClick }
  },
}
</script>
